// select-advanced-search.component.ts

import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, DoCheck } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

@Component({
  selector: 'app-select-advanced-search',
  templateUrl: './select-advanced-search.component.html',
  styleUrls: ['./select-advanced-search.component.sass'],
})

export class SelectAdvancedSearchComponent implements OnInit, OnDestroy, DoCheck {
  

  @Input() config: IFieldConfig;
  @Input() useCompare: boolean = true;
  @Input() isMultipleSelect: boolean = false;
  @Input() group: FormGroup;
  @Input() value: string;
  @Input() typeCes?: TypeCesEnum | undefined;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  
  public optionFilterCtrl: FormControl = new FormControl();
  public filteredOptions: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  private _onDestroy = new Subject<void>();

 
  private previousOptions: any[] | undefined;

  constructor() {}

  ngOnInit(): void {
    
    this.previousOptions = this.config?.options;
    this.updateOptionsList();

    this.optionFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterOptions();
      });
  }

  ngDoCheck(): void {
    
    if (this.config?.options !== this.previousOptions) {
      this.previousOptions = this.config.options;
      this.updateOptionsList();
    }
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  public compareFn = (o1: any, o2: any): boolean => {
    if (!this.useCompare) return o1 === o2;
    if (o1?.id && o2?.id) return o1.id === o2.id;
    return o1 === o2;
  };

  private updateOptionsList(): void {
    const options = this.config?.options || [];
    this.filteredOptions.next(options.slice());
    this.filterOptions();
  }

  private filterOptions(): void {
    const options = this.config?.options;
    if (!options) {
      this.filteredOptions.next([]);
      return;
    }
    
    let search = this.optionFilterCtrl.value;
    if (!search) {
      this.filteredOptions.next(options.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredOptions.next(
      options.filter(option => {
        const displayValue = this.getOptionDisplay(option).toLowerCase();
        return displayValue.includes(search);
      })
    );
  }

  private getOptionDisplay(option: any): string {
    if (!option) return '';
    if (this.config?.displayValue) return this.config.displayValue(option);
    if (this.config?.display) return option[this.config.display] ?? '';
    return option.toString();
  }

  public onChange(event: any): void {
    if (!(event.value instanceof Object)) {
      this.onSelect.emit(event.value);
      return;
    }
    let object = this.config?.options?.find(
      (it: any) => it[this.value] === event.value
    );
    this.onSelect.emit(object);
  }

  public getValue(): any {
    return this.group.get(this.config.name)?.getRawValue();
  }
}
